import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import MobilityDevicesList from '../../containers/global-settings/MobilityDevicesList'
import AddMobilityDeviceModal from '../../containers/global-settings/AddMobilityDeviceModal'
import EditMobilityDeviceModal from '../../containers/global-settings/EditMobilityDeviceModal'
import RemoveMobilityDeviceModal from '../../containers/global-settings/RemoveMobilityDeviceModal'
import { GLOBAL_SETTINGS_MOBILITY_DEVICES_COLUMN } from '../../state/constants/index'
import BackToList from '../ui/BackToList'

export default class MobilityDevicesPane extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddMobilityDeviceModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveMobilityDeviceModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditMobilityDeviceModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Mobility Devices</div>
            <div className='flex items-center justify-center'>
              <Link
                className='btn bg-green rounded font-white mr2 flex justify-center items-center'
                to='/global-settings/mobility-devices/create'
              >
                <Plus className='svg-white mr1' />
                Add Mobility device
              </Link>
            </div>
          </div>
          <hr />
          <div className='pr3 pl3'>
            <div className='flex justify-between pl3'>
              <div className='flex col-12'>
                <div className='col-3'>{GLOBAL_SETTINGS_MOBILITY_DEVICES_COLUMN.CATEGORY}</div>
                <div className='col-3'>{GLOBAL_SETTINGS_MOBILITY_DEVICES_COLUMN.NAME}</div>
                <div className='col-4'>{GLOBAL_SETTINGS_MOBILITY_DEVICES_COLUMN.ABLE_TO_TRANSFER_TO_A_SEAT}</div>
              </div>
            </div>
            <hr />
            <MobilityDevicesList />
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/MobilityDevicesPane.tsx